import React, { createContext, useState, useEffect, FC, Dispatch, SetStateAction, PropsWithChildren } from "react";
import { useFlags } from 'flagsmith/react';

interface IMainLayout {
    sidebarOpen?: boolean;
    setSidebarOpen?: Dispatch<SetStateAction<boolean>>;
    projectId?: string;
    criteriaId?: string;
    setProjectId?: (value: string) => void;
    setCriteriaId?: (value: string) => void;
    flags?: any;
}

const MainLayoutContext = createContext<IMainLayout>({
    sidebarOpen: false,
    setSidebarOpen: () => { },
    flags: {}
});

const MainLayoutProvider = ({ children }: PropsWithChildren<{}>) => {
    const [sidebarOpen, setSidebarOpen] = useState(localStorage.getItem('sidebarOpen') === 'true');
    const [projectId, setProjectId] = useState<string>(localStorage.getItem('projectId') || '');
    const [criteriaId, setCriteriaId] = useState<string>(localStorage.getItem('criteriaId') || '');

    const flags = useFlags(['sequences']);

    useEffect(() => {
        localStorage.setItem('sidebarOpen', sidebarOpen.toString());
    }, [sidebarOpen]);

    useEffect(() => {
        localStorage.setItem('projectId', projectId);
    }, [projectId]);

    useEffect(() => {
        localStorage.setItem('criteriaId', criteriaId);
    }, [criteriaId]);

    return (
        <MainLayoutContext.Provider
            value={{
                sidebarOpen,
                setSidebarOpen,
                projectId,
                criteriaId,
                setProjectId: (projectId: string) => setProjectId(projectId),
                setCriteriaId: (criteriaId: string) => setCriteriaId(criteriaId),
                flags
            }}>
            {children}
        </MainLayoutContext.Provider>
    );
};

export { MainLayoutContext, MainLayoutProvider };